<template>
  <div class="sl-item" style="display: flex; align-items: center; padding-bottom: 20px;">
    <a style="display: flex; align-items: center; width: 100%;">
      <div class="sl-avatar avatar avatar-sm avatar-circle">
        {{feed.created_at | moment("YYYY-MM-DD")}}
      </div>
      <div class="sl-content" style="flex: 4; display: flex; flex-direction: column; justify-content: center;">
        <p class="block txt-orange font-14 capitalize-font">{{feed.user_name}}</p>
        <p class="inline-block"><span>{{feed.message}}</span></p>
      </div>
      <div class="sl-content" style="flex: 1; display: flex; flex-direction: row; justify-content: flex-end; align-items: center;">
        <i v-if="needActionButtons" class="zmdi zmdi-delete action-button delete" @click="deleteFeedClicked"></i>
        <i v-if="needActionButtons" class="zmdi zmdi-edit action-button" @click="editFeedClicked"></i>
      </div>
    </a>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import BaseButton from "@/components/shared/buttons/BaseButton";
import FormInput from "@/components/shared/inputs/FormInput";

export default {
  name: "FeedCard",
  components: {
    "base-button": BaseButton,
    "form-input": FormInput,
  },
  props: {
    feed: {
      type: Object,
      required: true
    },
    needActionButtons: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      newMessage: '',
    };
  },
  created() {},
  computed: {
  },
  methods: {
    editFeedClicked() {
      this.$emit('editFeedClicked',this.feed.id)
    },
    deleteFeedClicked() {
      this.$emit('deleteFeedClicked',this.feed.id)
    }
  }
};
</script>

<style lang="scss" scoped>
.action-button {
  cursor: pointer;
  color: #272B34;
  float: right;
}

.delete {
  margin-right: 20px;
}

.year-section {
  top: 36px;
  left: -35px !important;
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/helpdesk/FeedCard.vue